import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {uniqBy} from "lodash";

export interface Identifiable {
  id: number | string;
}

@Injectable({
  providedIn: 'root'
})
export class EntityStoreService<T extends Identifiable> {
  private entitiesSubject = new BehaviorSubject<T[]>([]);

  entities$: Observable<T[]> = this.entitiesSubject.asObservable();

  setEntities(entities: T[]): void {
    this.entitiesSubject.next(uniqBy(entities, 'id'));
  }

  getEntitiesSnapshot(): T[] {
    return this.entitiesSubject.getValue();
  }

  addEntity(entity: T): void {
    const current = this.getEntitiesSnapshot();
    this.entitiesSubject.next([...current, entity]);
  }

  removeEntity(id: number): void {
    const current = this.getEntitiesSnapshot().filter(e => e.id !== id);
    this.entitiesSubject.next(current);
  }
}
